var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVectorHiw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1500,
    height: 105,
    viewBox: "0 0 1431 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 36.2274C308.531 219.886 521.943 -34.9837 778.073 28.7069C1105.98 110.245 1222.39 65.914 1430 1",
    stroke: "#9CA3AF",
    strokeLinecap: "round",
    strokeDasharray: "6 14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorHiw);
export default __webpack_public_path__ + "static/media/VectorHIW.fa0091d442cc4be7e79c45efe019ae2a.svg";
export { ForwardRef as ReactComponent };